import { render, staticRenderFns } from "./AttachmentList.vue?vue&type=template&id=23e9ccdc&scoped=true"
import script from "./AttachmentList.vue?vue&type=script&lang=js"
export * from "./AttachmentList.vue?vue&type=script&lang=js"
import style0 from "./AttachmentList.vue?vue&type=style&index=0&id=23e9ccdc&prod&lang=scss"
import style1 from "./AttachmentList.vue?vue&type=style&index=1&id=23e9ccdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e9ccdc",
  null
  
)

export default component.exports